import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import "./map.css"

mapboxgl.accessToken = 'pk.eyJ1IjoiaGloaWhpczIzIiwiYSI6ImNsZjlnOWRqYjF5a3AzdG9jMHhxbHVmanMifQ.hkY9gD22G_kmAGJcWvBzwg';

export default function Map({lng1, lat1}) {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState();
  const [lat, setLat] = useState();
  const [zoom, setZoom] = useState(13);


  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [lng1, lat1],
      zoom: zoom
    });
  }, [lng1, lat1]);

  return (
    <div>
      <div className="sidebar">
        Longitude: {lng1} | Latitude: {lat1}
      </div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );
}